module.exports = __webpack_public_path__ + "img/stat_map_ru.b55303c5.png";